// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"19b98005","488":"3776e8c6"}[chunkId] + ".chunk.js";
};